/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EvaluationEditableDto
 */
export interface EvaluationEditableDto {
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationEditableDto
     */
    isEditable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluationEditableDto
     */
    isDeletable?: boolean;
}

/**
 * Check if a given object implements the EvaluationEditableDto interface.
 */
export function instanceOfEvaluationEditableDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EvaluationEditableDtoFromJSON(json: any): EvaluationEditableDto {
    return EvaluationEditableDtoFromJSONTyped(json, false);
}

export function EvaluationEditableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationEditableDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isEditable': !exists(json, 'isEditable') ? undefined : json['isEditable'],
        'isDeletable': !exists(json, 'isDeletable') ? undefined : json['isDeletable'],
    };
}

export function EvaluationEditableDtoToJSON(value?: EvaluationEditableDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isEditable': value.isEditable,
        'isDeletable': value.isDeletable,
    };
}

